<template>
  <div class="base">
    <div>
      <label>仪器名称：</label><span>{{ row.checkmallWaresName }}</span>
    </div>
    <div>
      <label>委托金额：</label>
      <span class="base-price" v-if="row.orderPrice"
        >￥{{ row.orderPrice }}元</span
      >
      <span class="base-price" v-else>面议</span>
    </div>
    <div>
      <label>下单联系人：</label><span>{{ row.orderLinkman }}</span>
    </div>
    <div>
      <label>下单时间：</label><span>{{ row.createTime }}</span>
    </div>
    <div v-if="row.saleStatus">
      <label>退款审核状态：</label>
      <span class="base-refund">{{ REFUND_STATUS_TEXT[row.saleStatus] }}</span>
    </div>
  </div>
</template>
<script>
import { REFUND_STATUS_TEXT } from "@/constant/dict";
export default {
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      REFUND_STATUS_TEXT,
    };
  },
};
</script>
<style lang="scss" scoped>
.base {
  padding: 10px;
  > div {
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0px;
    }
    > label {
      color: #909399;
    }
  }
  &-price,
  &-refund {
    color: #f56c6c;
  }
}
</style>
